// extracted by mini-css-extract-plugin
var _1 = "E6DBo";
var _2 = "t2xjI";
var _3 = "zn5Xe";
var _4 = "jj7ca";
export { _1 as "empty", _2 as "insetLabel", _3 as "selectArrow", _4 as "selectArrowEmployee" }
